module.exports = __webpack_public_path__ + "img/close.f5835811.svg";